import { TableCell, styled } from "@mui/material";

export const JanusStyledTableCell = styled(TableCell)(() => ({
    paddingTop: "0.4rem",
    paddingBottom: "0.4rem"
}))